import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
  // results slider
  const resultsSwiper = new Swiper('#our-team .swiper', {
    modules: [Navigation, Pagination, A11y],
    navigation: {
      nextEl: '#our-team .swiper-button-next',
      prevEl: '#our-team .swiper-button-prev',
    },
    a11y: true,
    keyboardControl: true,
    grabCursor: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
  });
};
